export default __webpack_public_path__ + "static/media/bank.1c590f4c.svg";